import React, { Component } from 'react';
import {FormControl, Button,Row, Col,OverlayTrigger,Tooltip} from 'react-bootstrap';
import { translate } from "react-i18next";



  
class CommentEdit extends Component {

    constructor(props) {
        super(props);

        this.onCommentInputChange = this.onCommentInputChange.bind(this);
        this.state = {
            comment: this.props.selected,
            onCommentRevertP:this.props.onCommentRevertP
        };
    }

    onCommentInputChange(event) {
        const { name: fieldName, value: fieldValue } = event.target;
        const { comment } = this.state;

        const newComment = {
        ...comment,
        [fieldName]: fieldValue
        };

        this.setState({
        comment: newComment
        });
   }

   render() {
        const { t } = this.props;
        return (
           <div className=" p-2 mt-3">
                <Row className="mt-1">
                    <Col lg={10} md={10}>
                        <FormControl
                            as="textarea"
                            placeholder={t("KommentarEingeben")}
                            onChange={this.onCommentInputChange}
                            name="comment"
                            value={ this.state.comment.comment}
                        />
                    </Col>
                </Row>
                <Row className="mt-1 mb-5">
                 
                    <Col lg={1} md={1} xs={3}>
                    <OverlayTrigger
                        key="top"
                        placement="top"
                        overlay={
                        <Tooltip id={`tooltip-top`}>
                            {t("loeschen")}
                        </Tooltip>
                        }>
                        <Button variant="outline-primary" onClick={() => this.props.onCommentDelete(this.state.comment.id)}><span className="fa fa-trash-alt"></span></Button>
                        </OverlayTrigger>
                    </Col>
                    <Col lg={1} md={1} xs={3}>
                    <OverlayTrigger
                        key="top"
                        placement="top"
                        overlay={
                        <Tooltip id={`tooltip-top`}>
                             {t("verwerfen")}
                        </Tooltip>
                        }>
                            <Button variant="outline-primary" onClick={ this.props.onCommentRevert}><span className="fa fa-undo"></span></Button>
                        </OverlayTrigger>
                        
                    </Col>
                    <Col lg={1} md={1} xs={3}>
                    <OverlayTrigger
                        key="top"
                        placement="top"
                        overlay={
                        <Tooltip id={`tooltip-top`}>
                             {t("speichern")}
                        </Tooltip>
                        }>
                        <Button variant="outline-primary" onClick={() =>  this.props.onCommentEdit(this.state.comment)}><span className="fa fa-save"></span></Button>
                        </OverlayTrigger>
                    </Col>
                    <Col lg={7} md={7} xs={2}>
                        &nbsp;
                    </Col>
                </Row>
           </div>
        )
    }
}

export default translate("translations")(CommentEdit);